import gql from 'graphql-tag';

export default gql`
    mutation DietSetReplaceMutation($request: UserDietSetReplaceInputType) {
        me {
            dietSetReplace(request: $request) {
                __typename
                ... on UnauthorizedException {
                    code
                }
                ... on ValidationException {
                    code
                    messages
                    details {
                        fieldName
                        messages
                    }
                }
                ... on BasicMutationSuccess {
                    code
                }
            }
        }
    }
`;
